import DatabaseModel from './DatabaseModel.js';

var AiContextExamples = Object.create(DatabaseModel);

AiContextExamples.model = 'ai/agent/context/examples';
AiContextExamples.modelFront = 'ai/agent/context/examples';

export default AiContextExamples;
